import React, { ReactNode } from "react";
import { createContext, useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ROLES_BACKUP,
  ROLES_CONTACT_US,
  ROLES_CREATOR,
  DIVIDEND_MANAGEMENT,
  ROLES_DASHBOARD,
  ROLES_BOOKING,
  ROLES_FAQS,
  ROLES_VEHICLE,
  ROLES_TRANSACTION,
  ROLES_NOTIFICATION,
  ROLES_POLICIES,
  ROLES_COUPONS,
  ROLES_RIDES,
  ROLES_RIDEREPORT,
  ROLES_SALES,
  ROLES_STAFF_MEMBERS,
  ROLES_STREAMING,
  ROLES_USERS,
  ROLES_COLLECTION,
  // ROLES_RIDES,
} from "../constants/actionTypes";
import { SOLD, ON_SALE, ALL } from "../constants/actionTypes";
import henceforthApi from "../utils/henceforthApi";
import logoutSuccess from "./actions/auth/logoutSuccess";
import authInitialState from "./initialStates/authInitialState";
import authInitialStaticData from "./initialStates/authInitialStaticData";
import auth from "./reducers/auth";
import static_data from "./reducers/static_data";
import { toast } from 'react-toastify'
import { ethers } from "ethers";

import DIVIDENDS_CONTRACT_PATH from "../contracts/multi_eth_send/Dividends.sol/Dividends.json";
const DIVIDENDS_CONTRACT_ADDRESS = "0xCC970526b06E582Fe3fC4FD53484B7FcE4EdB17B"; //live
type Function = (page: number) => void
type ToastFunction = (msg: any) => void;
type Function1 = () => void
type Function2 = (name: string, value: string) => void
type GlobleContextProviderProps = {
  children: ReactNode;
}
interface CommonContextType {
  authState: { access_token: String, name: String, email: String | null, phone_number: number, image: String, super_admin: string, roles: any };
  handleFilter: Function2
  handlePagination: Function,
  handleError: ToastFunction;
  logOutNow: any,
  loading: Boolean,
  setLoading: any;
  disabledLoading: boolean,
  setDisabledLoading: any;
  staticDataDispatch: any;
  authDispatch: any;
  staffMembers: Array<string>;
  staticDataState: any


}
export const GlobalContext = createContext({} as CommonContextType);

function GlobalProvider(props: GlobleContextProviderProps) {
  let navigate = useNavigate();
  const location = useLocation()
  const [loading, setLoading] = useState(false);
  const [disabledLoading, setDisabledLoading] = useState(false)
  // const [currentUsd, setCurrenctUsd] = useState(0);
  // const [defaultAccount, setDefaultAccount] = useState(null);
  // const [userBalance, setUserBalance] = useState(null);


  const [authState, authDispatch] = useReducer(auth, authInitialState, () => {
    const localAuthState = localStorage.getItem("authState");
    return localAuthState ? JSON.parse(localAuthState) : authInitialState;
  });
  if (authState?.access_token) {
    henceforthApi.setToken(authState?.access_token);
  }
  console.log("adminData is", authState);

  const [staticDataState, staticDataDispatch] = useReducer(
    static_data,
    authInitialStaticData,
    () => {
      const localStaticDataState = localStorage.getItem("staticDataState");
      return localStaticDataState ? JSON.parse(localStaticDataState) : authInitialStaticData;
    }
  );
  let newparam = new URLSearchParams(location.search)
  const handleFilter = (name: string, value: string) => {
    console.log("filter name", name, "filter value", value)
    if (value) {
      newparam.set(name, value)
    } else {
      if (newparam.has(name)) {
        newparam.delete(name)
      }
    }
    if (location.pathname.startsWith("/users")) {
      navigate({ pathname: "/users/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/booked-rides")) {
      navigate({ pathname: "/booked-rides/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/saved-rides")) {
      navigate({ pathname: "/saved-rides/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/vehicles")) {
      navigate({ pathname: "/vehicles/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/transactions")) {
      navigate({ pathname: "/transactions/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/transfer")) {
      navigate({ pathname: "/transfer/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/coupons")) {
      navigate({ pathname: "/coupons/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/created-rides")) {
      navigate({ pathname: "/created-rides/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/contact-us")) {
      navigate({ pathname: "/contact-us/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/reported-rides")) {
      navigate({ pathname: "/reported-rides/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/report-user")) {
      navigate({ pathname: "/report-user/1", search: newparam.toString() })
    }

    if (location.pathname.startsWith("/faqs")) {
      navigate({ pathname: "/faqs/1", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/staff")) {
      navigate({ pathname: "/staff/1/all", search: newparam.toString() })
    }
    if (location.pathname.startsWith("/earnings-and-tax")) {
      navigate({ pathname: "/earnings-and-tax/1", search: newparam.toString() })
    }
  }
  const handlePagination = (page: number) => {

    if (location.pathname.startsWith("/earnings-and-tax")) {
      navigate({ pathname: `/earnings-and-tax/${page}`, search: newparam.toString() })
    }
    // navigate({pathname:`/booked-rides/${page}` , search:newparam.toString()})
    if (location.pathname.startsWith("/users")) {
      navigate({ pathname: `/users/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/booked-rides")) {
      navigate({ pathname: `/booked-rides/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/saved-rides")) {
      navigate({ pathname: `/saved-rides/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/vehicles")) {
      navigate({ pathname: `/vehicles/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/transactions")) {
      navigate({ pathname: `/transactions/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/transfer")) {
      navigate({ pathname: `/transfer/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/coupons")) {
      navigate({ pathname: `/coupons/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/created-rides")) {
      navigate({ pathname: `/created-rides/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/reported-rides")) {
      navigate({ pathname: `/reported-rides/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/report-user")) {
      navigate({ pathname: `/report-user/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/contact-us")) {
      navigate({ pathname: `/contact-us/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/faqs")) {
      navigate({ pathname: `/faqs/${page}`, search: newparam.toString() })
    }
    if (location.pathname.startsWith("/staff")) {
      navigate({ pathname: `/staff/${page}`, search: newparam.toString() })
    }
    // if(location.pathname.startsWith(`/vehicle-details`)){
    //   navigate({ pathname: `/vehicle-details/${page}`, search: newparam.toString() })

    // }
  }

  // const handleConnect = async () => {
  //   try {
  //     if (typeof window.ethereum !== "undefined") {
  //       const accounts = await window.ethereum.request({
  //         method: "eth_requestAccounts",
  //       });
  //       account = accounts[0];
  //       console.log(account, "add");
  //       accChangeHandler(accounts[0]);

  //       console.log("MetaMask is connected");
  //     }
  //   } catch (error:any) {
  //     console.log("install metamask", error);
  //   }
  // };
  // const accChangeHandler = (newAccount) => {
  //   setDefaultAccount(newAccount);
  //   getUserBalance(newAccount.toString());
  // };

  // const getUserBalance = async (address) => {
  //   try {
  //     const balance = await window.ethereum.request({
  //       method: "eth_getBalance",
  //       params: [address, "latest"],
  //     });

  //     setUserBalance(ethers.utils.formatEther(balance));
  //   } catch (error:any) {
  //     console.log(error);
  //   }
  // };


  // window.ethereum.on("account changed", accChangeHandler);
  // const adminData = JSON.parse(localStorage.getItem('authState'));
  //   const { authState } = useContext(GlobalContext);


  const scrollToTop = () => {
    if (window) {
      window.scrollTo(0, 0);
    }
  };

  const logOutNow = () => {
    // setDefaultAccount([]);
    logoutSuccess({})(authDispatch);
    logoutSuccess(authInitialStaticData)(staticDataDispatch);
    navigate("/", { replace: true });
  };

  const handleError = (error: any) => {
    let errorBody = error?.response?.body
    let error_type = errorBody?.error
    let message = errorBody?.error_description
    toast.error(message)
    if (error_type === "UNAUTHORIZED") {
      logOutNow()
    }
  }

  const filterNfts = [SOLD, ON_SALE, ALL];

  const staffMembers = [
    // ROLES_STAFF_MEMBERS,
    // ROLES_DASHBOARD,
    ROLES_USERS,
    // ROLES_CREATOR,
    // ROLES_NFTS,
    ROLES_BOOKING,
    ROLES_VEHICLE,
    ROLES_TRANSACTION,
    // ROLES_STREAMING,
    // ROLES_COLLECTION,

    // ROLES_SALES,
    ROLES_COUPONS,
    ROLES_RIDES,
    ROLES_RIDEREPORT,
    ROLES_FAQS,
    // DIVIDEND_MANAGEMENT,
    ROLES_POLICIES,
    ROLES_CONTACT_US,
    ROLES_NOTIFICATION,
    // ROLES_BACKUP,
  ];

  useEffect(() => {

    localStorage.setItem("authState", JSON.stringify(authState))
  }, [authState]);

  useEffect(() => {
    localStorage.setItem("staticDataState", JSON.stringify(staticDataState));
  }, [staticDataState]);

  return (
    <GlobalContext.Provider
      value={{
        authState,
        staffMembers,
        authDispatch,
        handleError,
        loading,
        setLoading,
        disabledLoading,
        setDisabledLoading,
        staticDataState,
        staticDataDispatch,
        logOutNow,
        handlePagination,
        handleFilter,
      }}>
      {props.children}
    </GlobalContext.Provider>
  );
}

export default GlobalProvider;
